import { render, staticRenderFns } from "./collectresourseList.vue?vue&type=template&id=c35096a8&scoped=true"
import script from "./collectresourseList.vue?vue&type=script&lang=js"
export * from "./collectresourseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35096a8",
  null
  
)

export default component.exports